import * as types from '../../types'
import app from '../../../api/app'

const state = {
  appId:'',
  appName:'',
  entryList:[],
  entryMap:{}
}

const actions = {
  listApplicationItem({commit}, appId) {
    app.listApplicationItem(appId).then((data) => {
      commit(types.LIST_APPLICATION_ITEM, data.result)
    });
  }
}

const getters = {
}

const mutations = {
  [types.LIST_APPLICATION_ITEM](state, result) {
    state.appName=result.name;
    state.entryList = result.entryList;
    state.entryMap= result.entryMap;
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/common/vuex/modules/app/appItem.js